import { gql } from 'apollo-boost';

export const getPageProductsQuery = gql`
  query Products($skip: Int!, $take: Int!, $category: ID) {
    Products(input: { category: $category, skip: $skip, take: $take }) {
      totalCount
      items {
        id
        code
        title
        description
        createDate
        images {
          id
          url
          thumbnailUrl
        }
        token
        shortLinkUrl
        totalHit
        totalView
        isVisible
        isAvailable
        category {
          id
          title
        }
        price
        discount
        links {
          id
          title
          url
          createDate
          logoName
          token
          shortLinkUrl
          totalHit
          isVisible
        }
      }
    }
  }
`;

export const getShopContactsPreviewQuery = gql`
  query ShopContactsPreview($pageName: String!) {
    ShopContactsPreview(input: { pageName: $pageName }) {
      id
      type
      logoName
      raw
      url
    }
  }
`;

export const getPagePreviewProductsQuery = gql`
  query ProductsPreview(
    $skip: Int!
    $take: Int!
    $category: ID
    $pageName: String!
  ) {
    ProductsPreview(
      input: {
        category: $category
        skip: $skip
        take: $take
        pageName: $pageName
      }
    ) {
      id
      code
      title
      description
      shortLink
      shortLinkUrl
      images {
        id
        url
        thumbnailUrl
      }
      isAvailable
      category {
        id
        title
      }
      price
      discount
    }
  }
`;

export const newProductQuery = gql`
  mutation NewProduct(
    $code: String!
    $title: String!
    $description: String
    $images: [ID!]!
    $shortLink: String!
    $category: ID!
    $price: Int!
    $discount: Int!
    $isAvailable: Boolean!
    $links: [NewInnerLinkInput!]
  ) {
    NewProduct(
      input: {
        code: $code
        title: $title
        description: $description
        images: $images
        shortLink: $shortLink
        category: $category
        price: $price
        discount: $discount
        isAvailable: $isAvailable
        links: $links
      }
    ) {
      id
      code
      title
      description
      createDate
      images {
        id
        url
        thumbnailUrl
      }
      token
      shortLinkUrl
      totalHit
      totalView
      isVisible
      isAvailable
      category {
        id
        title
      }
      price
      discount
      links {
        id
        title
        url
        createDate
        logoName
        token
        shortLinkUrl
        totalHit
        isVisible
      }
    }
  }
`;

export const editProductQuery = gql`
  mutation EditProduct(
    $id: ID!
    $code: String!
    $title: String!
    $description: String
    $images: [ID!]!
    $shortLink: String!
    $category: ID!
    $price: Int!
    $discount: Int!
    $isAvailable: Boolean!
    $links: [NewInnerLinkInput!]
  ) {
    EditProduct(
      input: {
        id: $id
        code: $code
        title: $title
        description: $description
        images: $images
        shortLink: $shortLink
        category: $category
        price: $price
        discount: $discount
        isAvailable: $isAvailable
        links: $links
      }
    ) {
      id
      code
      title
      description
      createDate
      images {
        id
        url
        thumbnailUrl
      }
      token
      shortLinkUrl
      totalHit
      totalView
      isVisible
      isAvailable
      category {
        id
        title
      }
      price
      discount
      links {
        id
        title
        url
        createDate
        logoName
        token
        shortLinkUrl
        totalHit
        isVisible
      }
    }
  }
`;

export const getProductBasketItems = gql`
  query GetProductBasketItems {
    ProductBasketItems @client
  }
`;

export const editShopContactsQuery = gql`
  mutation EditShopContacts($contacts: [EditShopContactInput]!) {
    EditShopContacts(input: $contacts) {
      id
      type
      raw
      url
      logoName
    }
  }
`;
